<template>
  <div class="flex min-h-screen">

    <nav class="w-16 tablet:w-250 border-r">
      <Nav />
    </nav>
    <!-- <navigation> -->

    <div class="flex flex-col w-full">
      <router-view class="flex-grow bg-white" /> <!-- content -->
      <Footer class="end bg-white" /> <!-- footer -->
    </div>

  </div>
</template>

<script>
import Nav from '@/components/layout/Navigation.vue';
import Footer from '@/components/layout/Footer.vue';

export default {
    name: 'blankLayout',
    props: {
        msg: String
    },
    components: {
        Footer,
        Nav
    }
};
</script>

<style scoped lang="scss">
</style>
